import { env } from '@repo/platform-env';
import type { SDKConfig } from '../types/absmartly';
import { getABSmartlyEnvironment } from '../utils/getABSmartlyEnvironment';

export const abSmartlySDKConfig: SDKConfig = {
  environment: getABSmartlyEnvironment(),
  application: 'cardfinder-v2',
  apiKey: env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
  endpoint: 'https://nerdwallet.absmartly.io/v1',
};
